export default [
  {
    path: '/supporting-documents',
    name: 'SupportingDocumentListCreate',
    component: () => import(/* webpackChunkName: "supporting-documents" */ '@/views/supporting-documents/ListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Documentos de soporte'
    }
  }
]